import { LogLevel } from '@azure/msal-browser';
import appConfig from './configs/app.config';


export const b2cPolicies = {
  names: {
    signUpSignIn: `${process.env.NEXT_PUBLIC_SIGNUP_SIGNIN}`,
    forgotPassword: `${process.env.NEXT_PUBLIC_FORGOT_PASSWORD}`,
  },
  authorities: {
    signUpSignIn: {
      authority: `${process.env.NEXT_PUBLIC_AUTHORITY_URL}/${process.env.NEXT_PUBLIC_SIGNUP_SIGNIN}`,
    },
    forgotPassword: {
      authority: `${process.env.NEXT_PUBLIC_AUTHORITY_URL}/${process.env.NEXT_PUBLIC_FORGOT_PASSWORD}`,
    },
  },
  authorityDomain: `${process.env.NEXT_PUBLIC_AUTHORITY_DOMAIN}`,
};

export const msalConfig = {
  auth: {
    clientId: `${process.env.NEXT_PUBLIC_CLIENT_ID}`,
    authority: b2cPolicies.authorities.signUpSignIn.authority,
    knownAuthorities: [b2cPolicies.authorityDomain],
    redirectUri: `${appConfig.frontendUrl}`,
    postLogoutRedirectUri: '/',
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true,
    secureCookies: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
    },
  },
};

export const protectedResources = {
  api: {
    endpoint: `${appConfig.apiPrefix}`,
    scopes: {
      read: [`${process.env.NEXT_PUBLIC_SCOPE_READ}`],
    },
  },
};

export const loginRequest = {
  scopes: [...protectedResources.api.scopes.read],
};
